import React, { Component } from 'react';
import { translate } from '../Services/translation';
import LoadingButton from './LoadingButton';

class CheckoutCampaignCode extends Component {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            isLoading: false,
            isCompleted: false,
            isError: false,
            campaignCode: "",
        };
    }

    reset(campaignCode) {
        clearTimeout(this.state.timeout);
        this.setState({...this.getInitialState(), campaignCode: campaignCode});
    }

    onSubmit() {
        this.setState({ isLoading: true});
        this.props.onSubmitCampaignCode()
    }

    onInputChanged(event) {
        this.setState({campaignCode: event.target.value});
        this.props.onCampaignCodeChange(event.target.value);
    }

    componentDidUpdate(prevProps, prevState) {
        const isError = this.props.errors['campaignCode'] && this.props.errors['campaignCode'][0] ? true : false;
        const isCompleted = this.props.errors['campaignCode'] && !this.props.errors['campaignCode'][0] ? true : false;
        const campaignCode = this.state.campaignCode;

        if (isError !== prevState.isError && prevState.isError === false) {
            this.setState({isError: isError, campaignCode: campaignCode, timeout: setTimeout(() => {
                this.reset(campaignCode)
            }, 2000)});
           
        }

        if (isCompleted !== prevState.isCompleted && prevState.isCompleted === false) {
            this.setState({isCompleted: isCompleted, campaignCode: campaignCode, timeout: setTimeout(() => {
                this.reset(campaignCode)
            }, 2000)});
        }
    }

    render() {
        const isLoading = this.state.isLoading && !this.state.isError && !this.state.isCompleted;

        return (
            <div id="campaign-section" className="row">
                <div className="input-holder">
                    <input className="form__input" id="campaign-code" placeholder={translate('checkout.campaigncode')}
                        onChange={(event) => this.onInputChanged(event)} />
                    {this.props.errors['campaignCode'] && this.props.errors['campaignCode'][0] && <span id="input-error"className="form__validator--error form__validator--top-narrow" data-error-for="campaign-code">
                        {this.props.errors['campaignCode'] && this.props.errors['campaignCode'][0]}
                    </span>}
                </div>

                <LoadingButton 
                    onClick={() => this.onSubmit()}
                    submitText = {translate('checkout.usecampaigncode')}
                    isLoading={isLoading} isCompleted={this.state.isCompleted} isError={this.state.isError}
                    />
            </div>
        )
    }
}

export default CheckoutCampaignCode;
